import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// About activity items
export const ActivityItem = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: 'rgba(199, 112, 240, 0.05)',
  border: '1px solid transparent',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-5px)',
    borderColor: '#c770f0',
    boxShadow: '0 8px 20px rgba(199, 112, 240, 0.4)',
    background: 'rgba(199, 112, 240, 0.1)',
  },
  // Shimmer effect
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
    transition: 'left 0.5s ease',
  },
  '&:hover::after': {
    left: '100%',
  },
}));

// Enhanced activity item with floating emojis
export const EnhancedActivityItem = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background:
    'linear-gradient(135deg, rgba(138, 73, 168, 0.1) 0%, rgba(82, 52, 121, 0.1) 100%)',
  border: '2px solid transparent',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 25px rgba(138, 73, 168, 0.3)',
    borderColor: '#8a49a8',
  },
  // Shimmer effect
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
    transition: 'left 0.5s ease',
  },
  '&:hover::after': {
    left: '100%',
  },
}));

// Game activity with floating controller emoji
export const GameActivityItem = styled(EnhancedActivityItem)({
  '&:hover::before': {
    content: '"🎮"',
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    fontSize: '2em',
    animation: 'gameFloat 2s ease-in-out infinite',
    zIndex: 1,
  },
});

// Horror activity with floating ghost emoji
export const HorrorActivityItem = styled(EnhancedActivityItem)({
  '&:hover::before': {
    content: '"👻"',
    position: 'absolute',
    top: '-15px',
    right: '-15px',
    fontSize: '2.5em',
    animation: 'ghostFloat 3s ease-in-out infinite',
    zIndex: 1,
  },
});

// Sci-Fi activity with floating rocket emoji
export const ScifiActivityItem = styled(EnhancedActivityItem)({
  '&:hover::before': {
    content: '"🚀"',
    position: 'absolute',
    top: '-20px',
    right: '-20px',
    fontSize: '2.2em',
    animation: 'rocketLaunch 2.5s ease-in-out infinite',
    zIndex: 1,
  },
});

// Activity content wrapper
export const ActivityContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  position: 'relative',
  zIndex: 2,
}));

// Activity icon wrapper
export const ActivityIconWrapper = styled(Box)({
  color: '#8a49a8',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.2) rotate(10deg)',
  },
});

// Activity text
export const ActivityText = styled(Typography)({
  fontWeight: 500,
  color: '#fff',
  transition: 'color 0.3s ease',
  flexGrow: 1,
});

// Activity description chip
export const ActivityDescriptionChip = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  background: 'rgba(138, 73, 168, 0.9)',
  color: 'white',
  padding: theme.spacing(1, 2),
  borderRadius: '0 0 10px 10px',
  fontSize: '0.9em',
  textAlign: 'center',
  animation: 'slideDown 0.3s ease',
  zIndex: 3,
}));

// Quote card styles
export const QuoteCardView = styled(Box)({
  border: 'none',
  color: 'white',
  backgroundColor: 'transparent',
});
